<template>
  <div class="i-landing-trust">
    <div
      class="item"
      :class="{ vis: visible }"
      style="transition-delay: 0.65s"
    >
      <div class="number">
        <span ref="counterEl">{{ displayCount.toLocaleString() }}</span>
      </div>
      <div class="label">Professionals helped</div>
    </div>
    <div
      class="item"
      :class="{ vis: visible }"
      style="transition-delay: 0.73s"
    >
      <div class="number">
        <span class="accent">100%</span>
      </div>
      <div class="label">Confidential</div>
    </div>
    <div
      class="item"
      :class="{ vis: visible }"
      style="transition-delay: 0.81s"
    >
      <div class="number">
        <span class="accent">4.9 STARS</span>
      </div>
      <div class="label">Verified Reviews</div>
    </div>
  </div>
</template>

<script setup>
import { ref, watch, onUnmounted } from "vue"

const props = defineProps({ visible: Boolean })

const TARGET = 11384
const displayCount = ref(0)
let liveTimer = null

function easeOut(x) {
  return 1 - Math.pow(1 - x, 3)
}

function startCounter() {
  const duration = 1400
  const start = performance.now()
  function tick(now) {
    const p = Math.min((now - start) / duration, 1)
    displayCount.value = Math.round(easeOut(p) * TARGET)
    if (p < 1) {
      requestAnimationFrame(tick)
    } else {
      startLiveTick()
    }
  }
  requestAnimationFrame(tick)
}

function startLiveTick() {
  let n = TARGET
  function schedule() {
    const delay = 2000 + Math.random() * 5000
    liveTimer = setTimeout(() => {
      n++
      displayCount.value = n
      schedule()
    }, delay)
  }
  schedule()
}

watch(
  () => props.visible,
  (v) => {
    if (v) setTimeout(startCounter, 80)
  },
  { immediate: true }
)

onUnmounted(() => {
  if (liveTimer) clearTimeout(liveTimer)
})
</script>

<style lang="scss" scoped>
.i-landing-trust {
  display: grid;
  grid-template-columns: repeat(3, 1fr);

  .item {
    text-align: center;
    padding: 0 6px;
    position: relative;
    opacity: 0;
    transform: translateY(5px);
    transition: all 0.38s ease;

    &.vis {
      opacity: 1;
      transform: translateY(0);
    }

    & + & {
      &::before {
        content: "";
        position: absolute;
        left: 0;
        top: 4px;
        bottom: 4px;
        width: 1px;
        background: #0a0e1a0f;
      }
    }
  }

  .number {
    font-family: $serif;
    font-size: clamp(18px, 4.5vw, 24px);
    font-weight: 500;
    color: #111827e6;
    line-height: 1;
    margin-bottom: 3px;
    letter-spacing: -0.02em;

    @include respond-to($breakpoint-md) {
      font-size: clamp(18px, 2vw, 26px);
    }
  }

  .accent {
    color: $amber-mid;
  }

  .label {
    font-size: 9px;
    font-weight: 600;
    letter-spacing: 0.1em;
    text-transform: uppercase;
    color: $slate;
    line-height: 1.4;
  }
}
</style>
